import getScrollAccessor from './getScrollAccessor';
/**
 * Gets or sets the scroll left position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */

export default getScrollAccessor('pageXOffset');